import Home from '../views/Home.vue'
import Users from '../views/Users/Users.vue'
import Settings from "../views/Settings/Settings";
import Display from "../views/Display/Display";
import EmergencyStop from "../views/EmergencyStop/EmergencyStop";
import Logs from "../views/Logs";
import JsonEditor from "../views/JSON Editor/JsonEditor";
import Video from "../views/Video";
import Unauthorized from "../views/Unauthorized";
import Error404 from "../views/Error404";

const routes = [
    {
        path: '/',
        name: 'home',
        meta: {
            title: 'Molten-Core Ad Control'
        },
        component: Home
    },
    {
        path: '/display',
        name: 'display',
        component: Display,
        meta: {
            title: 'Verwaltung Display | Molten-Core Ad Control',
            //access = user groups that have access to the route. If access doesn't exist -> all groups can access the route
            access: ['admin', 'display', 'video', 'read', 'native'],
            //editRights = user groups that can edit inside the route. If editRights doesn't exist -> all groups can edit
            editRights: ['admin', 'display'],
        },
    },
    {
        path: '/video',
        name: 'video',
        component: Video,
        meta: {
            title: 'Verwaltung Video | Molten-Core Ad Control',
            access: ['admin', 'display', 'video', 'read'],
            editRights: ['admin', 'video'],
        },
    },
    {
        path: '/emergencystop',
        name: 'emergencystop',
        component: EmergencyStop,
        meta: {
            title: 'Not-Aus | Molten-Core Ad Control',
            access: ['admin', 'display'],
            editRights: ['admin', 'display'],
        },
    },
    {
        path: '/logs',
        name: 'logs',
        component: Logs,
        meta: {
            title: 'Logs | Molten-Core Ad Control',
            access: ['admin'],
            editRights: ['admin'],
        },
    },
    {
        path: '/jsoneditor',
        name: 'jsoneditor',
        component: JsonEditor,
        meta: {
            title: 'JSON-Editor | Molten-Core Ad Control',
            access: ['admin', 'display', 'native'],
            editRights: ['admin', 'display', 'native']
        },
    },
    {
        path: '/users',
        name: 'users',
        component: Users,
        meta: {
            title: 'Benutzerverwaltung | Molten-Core Ad Control',
            access: ['admin'],
            editRights: ['admin']
        },
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        meta: {
            title: 'Einstellungen | Molten-Core Ad Control',
            access: ['admin'],
            editRights: ['admin']
        },
    },
    {
        path: '/unauthorized',
        name: 'unauthorized',
        component: Unauthorized,
        meta: {
            title: 'Permission denied | Molten-Core Ad Control'
        }
    },
    {
        path: '*',
        name: 'error',
        meta: {
            title: 'Page not found | Molten-Core Ad Control'
        },
        component: Error404
    }
];

export default routes;
